import React, { useState } from "react";
import { Bot, Loader2, Send } from "lucide-react";
import { api } from "../../lib/api";
import { act } from "../../lib/sales";

// AI role-play: the AI plays a fictional business owner; type "COACH:" for coaching tips.
export function Roleplay({ courseId }) {
  const [msgs, setMsgs] = useState([]);
  const [text, setText] = useState("");
  const [busy, setBusy] = useState(false);
  async function send(t) {
    const hist = t === null ? [] : [...msgs, { role: "rep", text: t }];
    setMsgs(hist); setText(""); setBusy(true);
    const r = await act(() => api.post("/academy/roleplay", { course_id: courseId, history: hist }));
    setBusy(false);
    if (r) setMsgs([...hist, { role: "owner", text: r.reply }]);
  }
  return (
    <div className="rounded-2xl border border-[var(--line)] p-3 space-y-2" data-testid="academy-roleplay">
      <div className="flex items-center gap-2"><Bot className="w-4 h-4 text-[var(--gold)]" /><p className="text-sm font-semibold flex-1">Practice call (fictional TRAINING business)</p>
        <button onClick={() => send(null)} disabled={busy} className="btn-outline-gold text-xs !py-1" data-testid="academy-roleplay-start">{msgs.length ? "Restart" : "Start call"}</button></div>
      <div className="max-h-72 overflow-y-auto space-y-1.5" data-testid="academy-roleplay-msgs">{msgs.map((m, i) => <p key={i} className={`text-sm rounded-xl px-3 py-2 ${m.role === "rep" ? "bg-[var(--gold)]/15 ml-8" : "bg-black/5 mr-8"}`}><b>{m.role === "rep" ? "You" : "Owner"}:</b> {m.text}</p>)}
        {busy && <Loader2 className="w-4 h-4 animate-spin text-[var(--gold)]" />}</div>
      {msgs.length > 0 && <form onSubmit={(e) => { e.preventDefault(); if (text.trim()) send(text.trim()); }} className="flex gap-2">
        <input value={text} onChange={(e) => setText(e.target.value)} placeholder='Your reply… (start with "COACH:" for tips)' className="flex-1 rounded-full border border-[var(--line)] px-3 py-1.5 text-sm bg-transparent" data-testid="academy-roleplay-input" />
        <button disabled={busy || !text.trim()} className="btn-gold !py-1.5 text-xs disabled:opacity-40" data-testid="academy-roleplay-send"><Send className="w-3.5 h-3.5" /></button></form>}
    </div>
  );
}
